export default "__VITE_ASSET__badeec3c__"